import { Thumbmark } from "@thumbmarkjs/thumbmarkjs";

export const getBrowserKey = async () => {
  try {
    const thumbmark = new Thumbmark();
    const result = await thumbmark.get();
    return result.thumbmark;
  } catch (error) {
    console.error("Failed to generate browser key", error);
    return null;
  }
};
